<template>
  <div class="p-10 text-center">
    Please wait, loading...
  </div>
</template>

<script>
import Api from "@/api";

export default {
  name: "SalesForceCallback",
  data() {
    return {
      userid: null,
      orderid: null,
      env:null,
    };
  },
  

  created() {
    this.$root.$emit("hideLayout", {hide: true});
  },

  mounted() {
    
    const sfd = JSON.parse(localStorage.getItem('sfoauthdata'));
    this.userid = sfd.userid;
    this.orderid = sfd.orderid;
    this.env = sfd.env;
    localStorage.removeItem('sfoauthdata');

    this.init();
  },

  methods: {
    async init() {
      
      let authCode = this.$route.query.code;

      if (authCode) {
        await Api.callSalesForceCallback({
          userid: this.userid,
          code: authCode,
          orderid: this.orderid,
          env: this.env,
        });
      }

      window.close();
      this.$root.$emit("hideLayout", {hide: false});
    }
  },

  computed: {
    user() {
      return this.$store.getters.personalDetails;
    },
  }
};
</script>
